import React from 'react';

import './src/styles/codeStyle.css';

export const wrapPageElement = ({ element, props }) => {
  const Layout = element.type.Layout ?? React.Fragment;
  return <Layout {...props}>{element}</Layout>;
};
